<div class="product-table-block">
  <ng-container *ngIf="column && element">
    <ng-container *ngIf="column === 'actions && role' ; else dataCell">
      <div class="actions-block">
        <span
          class="material-icons"
          (click)="edit(); $event.stopPropagation()"
          title="Editer cet élément"
          >edit</span
        >
        <span
          class="material-icons"
          title="Supprimer cet élément"
          >delete</span
        >
      </div>
    </ng-container>
    <ng-template #dataCell>
      <div class="content-block">
        {{ element[column] | truncate: 60 }}
      </div>
    </ng-template>
  </ng-container>
</div>
